import React, { useState } from "react";
import CallsLayout from "../callsModule/common/CallLayout.jsx";
import OutboundChat from "./ChatsPanel.jsx";
import ConversationTab from "./conversationChat.jsx";
import CustomerNotes from "../callsModule/common/TabNotes.jsx";
import CustomerProfile from "../callsModule/common/TabProfile.jsx";
import CustomerHistory from "../callsModule/common/TabHistory.jsx";
import CustomerTexts from "../callsModule/common/TabTexts.jsx";
import CustomerCallsHistory from "../callsModule/common/TabCallsHistory.jsx";
import CustomerEmails from "../callsModule/common/TabEmails.jsx";
import CustomerDataset from "../callsModule/common/TabDataset.jsx";
import CustomerChats from "../callsModule/common/TabChats.jsx";
import SearchCustomer from "../callsModule/incoming/SearchCustomer.jsx";

const OutgoingChats = () => {
  const [customerGuid, setCustomerGuid] = React.useState(null);

  // Keep a single source of truth for the selected thread ID
  const [activeThreadId, setActiveThreadId] = useState(
    localStorage.getItem("activeThreadId") || ""
  );

  const tabs = [
    {
      label: "Conversation",
      value: "Conversation",
      component: <ConversationTab threadId={activeThreadId} customerguid={customerGuid}/>,
    },
    { label: "Profile", value: "Profile", component: <CustomerProfile customerguid={customerGuid}/> },
    { label: "Dataset", value: "Dataset", component: <CustomerDataset customerguid={customerGuid}/> },
    { label: "Notes", value: "Notes", component: <CustomerNotes customerguid={customerGuid}/> },
    { label: "History", value: "History", component: <CustomerHistory customerguid={customerGuid}/> },
    { label: "Payments", value: "Payment", component: <div>Payment</div> },
    { label: "Calls", value: "Calls", component: <CustomerCallsHistory customerguid={customerGuid}/> },
    { label: "Texts", value: "Texts", component: <CustomerTexts customerguid={customerGuid}/> },
    { label: "Emails", value: "Emails", component: <CustomerEmails customerguid={customerGuid}/> },
    { label: "Chats", value: "Chat", component: <CustomerChats customerguid={customerGuid}/> },
  ];

  const handleSelectedCustomer = (guid, id, callConnectionId) => {
    setCustomerGuid(guid);
  };

  const handleGuid = (guid) => {
    setCustomerGuid(guid);
  }

  // Filter tabs based on customerGuid
  const filteredTabs = customerGuid
    ? tabs
    : tabs.filter(tab => tab.value === "Conversation");

  const menuAction = [];
  if(!customerGuid){
    menuAction.push(
      {
        component: <SearchCustomer onCustomerGuid={handleGuid} />,
      })
  }
  
  return (
    <CallsLayout
      leftPanel={
        <OutboundChat
          onCustomerGuid={handleSelectedCustomer}
          currentThreadId={activeThreadId}
          onThreadSelected={({ threadId }) => {
            setActiveThreadId(threadId);
            // also store so other parts of the app (or a refresh) can pick it up
            localStorage.setItem("activeThreadId", threadId);
          }}
        />
      }
      menuActions={menuAction}
      tabConfig={filteredTabs}
      defaultTab="Conversation"
      title="Customer Information"

    />
  );
};

export default OutgoingChats;
